import axios from "axios"
import { getAuthToken, removeAuthToken, setAuthToken } from "utils/authUtil"

const headers = {}

// const BaseURL = "https://elmisbackend.support.af/api"
const BaseURL = "https://api.elmis.af/api"
// const BaseURL = "https://api.afga.elmis.af/api"
// const BaseURL = "http://localhost:8000/api"
// const BaseURL = "http://backend.test/api"

// Customize Axios based Authentication Token
const axiosInstance = axios.create({
  baseURL: BaseURL,
  headers,
})

// Interceptor for request
axiosInstance.interceptors.request.use(
  config => {
    const token = getAuthToken()
    if (token) {
      config.headers["Authorization"] = `Bearer ${token.access_token}`
    }
    config.headers["Accept"] = "application/json"
    config.headers["Content-Type"] = "application/json"

    return config
  },
  error => {
    console.log(error)
  }
)

// Interceptor for response
axiosInstance.interceptors.response.use(
  response => {
    return response
  },

  async error => {
    try {
      // get token from local storage
      const token = getAuthToken()
      const originalRequest = error?.config
      if (
        (error?.response?.status === 401 || error?.response?.status === 403) &&
        !originalRequest._retry
      ) {
        // if token has expired to refresh token will call
        originalRequest._retry = true
        const response = await axios.post(`${BaseURL}/v1/refresh-token`, {
          refresh_token: token.refresh_token,
        })
        setAuthToken(response?.data?.data)
        return axiosInstance(originalRequest)
      }
      return Promise.reject(error)
    } catch (error) {
      // else remove token and go to login
      removeAuthToken()
      window.location.href = "/login"
    }
  }
)

export default axiosInstance
